import { FunctionComponent } from 'react';
import classnames from 'classnames';

// Components
import Anchor from '@Components/Utils/Anchor';
import ImgLazy from '@Components/Utils/Lazy/Image';
import Access from '@Components/Layout/Components/Access';
import Dropdown from '@Components/Layout/Components/Dropdown';
import Notification from '@Components/Layout/Components/Notification';
// import ScheduleBooking from '@Components/Layout/Components/ScheduleBooking';

// Analytics
import { trackingEvent } from '@Components/Utils/Lazy/Script';

// Utils
import { getAttachmentAvatar, getUrl } from '@Libs/utils';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';

// Styles
import styles from '../HeaderNavbar.module.scss';

// Contexts
import { useAppStore } from '@Components/AppStore/Context';
import { useAccountContext } from '@Components/Account/Contexts';

// Config
import host from '@Config/host';

const LINK_CONG_DONG = '/hoi-dap';

const HEADER_MENU = [
    {
        type: 'dropdown',
        name: 'Thông tin',
        description: 'Cộng đồng, tin tức sức khoẻ',
        child: [
            {
                link: LINK_CONG_DONG,
                title: 'CỘNG ĐỒNG',
                image: '/assets/homeNavbar/community.png',
                subTitle: 'Cộng đồng hỏi đáp sức khỏe do đội ngũ Bác sĩ chuyên môn tư vấn.',
            },
            {
                link: '/bai-viet',
                title: 'TIN TỨC SỨC KHỎE',
                image: '/assets/homeNavbar/news_health.png',
                subTitle: 'Khám phá bài viết với các chủ đề đa dạng, cập nhật thông tin y tế mới nhất.',
            },
        ],
    },
    // {
    //     type: 'dropdown',
    //     name: 'Dịch vụ',
    //     description: 'Danh sách các dịch vụ',
    //     child: [
    //         {
    //             title: 'KHÁM TỔNG QUÁT',
    //             subTitle: 'Khám sức khỏe tổng quát và tầm soát các bệnh lý như ung thư, tiểu đường, gout, tim mạch, đột quỵ, v.v...',
    //             image: '/assets/homeNavbar/community.png',
    //             link: getUrl('/kham-tong-quat.html'),
    //         },
    //         {
    //             title: 'CHĂM SÓC TẬN NƠI',
    //             subTitle: 'Chăm sóc cho người bệnh và người cao tuổi tại nhà hoặc tại bệnh viện.',
    //             image: '/assets/homeNavbar/news_health.png',
    //             link: getUrl('/cham-soc-tan-noi.html'),
    //         },
    //         {
    //             title: 'LẤY MẪU TẠI NHÀ',
    //             subTitle: 'Không cần chờ đợi, không cần nhịn ăn vì đã có Điều dưỡng eDoctor đến lấy mẫu xét nghiệm tại nhà giúp bạn.',
    //             image: '/assets/homeNavbar/community.png',
    //             link: getUrl('/xet-nghiem-tai-nha.html'),
    //         },
    //         {
    //             title: 'KHÁM DOANH NGHIỆP',
    //             subTitle: 'eDoctor vinh dự được hàng trăm doanh nghiệp lựa chọn làm dịch vụ khám sức khỏe định kỳ cho nhân viên.',
    //             image: '/assets/homeNavbar/news_health.png',
    //             link: getUrl('/doanh-nghiep.html'),
    //         },
    //     ],
    // },
    {
        type: 'dropdown',
        name: 'Dịch vụ',
        description: 'Danh sách các dịch vụ',
        child: [
            {
                title: 'KHÁM TỔNG QUÁT',
                subTitle: 'Kiểm tra toàn diện, hiểu rõ sức khỏe của bạn',
                image: '/assets/homeNavbar/kham_tq_icon.png',
                link: '/kham-tong-quat',
            },
            {
                title: 'XÉT NGHIỆM TẠI NHÀ',
                subTitle: 'Không cần chờ đợi, điều dưỡng sẽ lấy mẫu tận nơi',
                image: '/assets/homeNavbar/xet_nghiem_tai_nha_icon.png',
                link: '/xet-nghiem-tai-nha',
            },
            {
                title: 'XÉT NGHIỆM DI TRUYỀN',
                subTitle: 'Hiểu rõ sức khỏe di truyền, khám phá tính trạng tiềm ẩn',
                image: '/assets/homeNavbar/xet_nghiem_gen_icon.png',
                link: '/xet-nghiem-gen',
            },
            {
                title: 'TẦM SOÁT UNG THƯ',
                subTitle: 'Phát hiện và ngăn ngừa các bệnh ung thư',
                image: '/assets/homeNavbar/tam_soat_ung_thu_icon.png',
                link: '/tam-soat-ung-thu',
            },
            {
                title: 'Tất cả dịch vụ',
                subTitle: 'Lựa chọn dịch vụ theo nhu cầu của bạn',
                image: '/assets/homeNavbar/tat_ca_dich_vu.png',
                link: getUrl('/danh-muc/edoctor-app-dich-vu-pho-bien.html'),
            },
        ],
    },
    // {
    //     type: 'link',
    //     name: 'Dịch vụ',
    //     description: 'Danh sách các dịch vụ',
    //     link: getUrl('/dich-vu'),
    // },
    {
        type: 'link',
        name: 'Hỏi Bác sĩ',
        description: 'Tư vấn Bác sĩ trực tuyến',
        link: '/hoi-dap',
    },
    {
        type: 'link',
        name: 'Nhà thuốc',
        description: 'Mua thuốc trực tuyến',
        link: getUrl('/', host.epharmacyDomain),
    },
    {
        type: 'dropdown',
        name: 'Dành cho đối tác',
        description: 'Bác sĩ, CTV, phòng khám',
        child: [
            {
                title: 'Bác sĩ',
                link: '/bac-si',
                image: '/assets/homeNavbar/doctor.png',
                subTitle: 'Giúp hàng ngàn người dùng với những vấn đề sức khỏe không được giải đáp.',
            },
            {
                link: '/cong-tac-vien',
                title: 'ĐIỀU DƯỠNG (CTV)',
                image: '/assets/homeNavbar/nurse.png',
                subTitle: 'Hỗ trợ lấy mẫu xét nghiệm tại nhà.',
            },
            {
                title: 'PHÒNG KHÁM',
                subTitle: 'Cung cấp giải pháp công nghệ giúp các phòng khám hoạt động hiệu quả hơn nữa',
                image: '/assets/homeNavbar/clinic.png',
                link: '/tra-cuu/phong-kham',
            },
        ],
    },
];

// const PARTNERS = ;

interface DesktopNavbarProps {}

const DesktopNavbar: FunctionComponent<DesktopNavbarProps> = () => {
    const { summary, toggleModal } = useAccountContext();
    const { countNotification } = useAppStore();

    const self: any = (summary?.consumer?.profiles || []).find(({ relation }) => relation === 'self') || {};

    const handleTrackingClickNotification = () => {
        gtag('event', 'click', {
            event_category: 'Click',
            event_label: 'Desktop navbar - Notification',
        });
    };

    const handleTrackingClickAvatar = () => {
        gtag('event', 'click', {
            event_category: 'Click',
            event_label: 'Desktop navbar - User Avatar',
        });
    };

    const handleTrackingClickSearch = () => {
        gtag('event', 'click', {
            event_category: 'Click',
            event_label: 'Desktop navbar - Search',
        });
    };

    const handleClick = (link: string) => {
        if (link === LINK_CONG_DONG) {
            trackingEvent('nhấp vào trang "Cộng đồng"', 'Home Screen');
        }
    };

    const renderItemMenu = (menu: Array<{ title: string; subTitle: string; image: string }>) => {
        return menu.map((item: any, index) => (
            <Anchor
                href={item.link}
                onClick={() => handleClick(item.link)}
                key={`dropdown-menu-item-${index}`}
                className={classnames(styles.dropdown_menu_item, {
                    [styles.all_service]: item.title === 'Tất cả dịch vụ',
                })}
            >
                <ImgLazy src={item.image} className={styles.image} width={'48px'} height={'48px'} />
                <div className={styles.item_content}>
                    <span className={styles.item_title}>{item.title}</span>
                    <span className={styles.item_sub_title}>{item.subTitle}</span>
                </div>
                <FontAwesomeIcon className={styles.item_icon} icon={faAngleRight} />
            </Anchor>
        ));
    };

    const renderMenu = () => {
        return HEADER_MENU.map((menu: any, index) => {
            if (menu.type === 'dropdown') {
                return (
                    <Dropdown
                        key={`dropdown-item-${index}`}
                        className={styles.menu_item}
                        itemProps={renderItemMenu(menu.child)}
                        dropdownMenuClassName={styles.dropdown_menu}
                    >
                        <div className={styles.title}>
                            {menu.name}
                            <FontAwesomeIcon className={styles.icon} icon={faCaretDown} />
                        </div>
                        <span className={styles.sub_title}>{menu.description}</span>
                    </Dropdown>
                );
            }

            if (menu.disabled) {
                return (
                    <a href="#" key={`link-item-${index}`} className={classnames([styles.menu_item, styles.disabled])}>
                        <div className={styles.title}>{menu.name}</div>
                        <span className={styles.sub_title}>{menu.description}</span>
                    </a>
                );
            }

            return (
                <Anchor key={`link-item-${index}`} href={menu.link} className={styles.menu_item}>
                    <div className={styles.title}>{menu.name}</div>
                    <span className={styles.sub_title}>{menu.description}</span>
                </Anchor>
            );
        });
    };

    const iconSearchClass = classnames([
        styles.icon_search,
        {
            [styles.auth]: summary,
        },
    ]);

    return (
        <>
            <div className={styles.left}>{renderMenu()}</div>
            <div className={styles.right}>
                <Anchor href="/tra-cuu" onClick={handleTrackingClickSearch}>
                    <ImgLazy className={iconSearchClass} src="/assets/navbar/menu/search.svg" />
                </Anchor>
                {summary ? (
                    <>
                        {/* <Dropdown right itemProps={<ScheduleBooking />} className={styles.dropdown} dropdownMenuClassName={classnames([styles.dropdown_menu])}>
                            <div className={styles.with_notification}>
                                <Image className={styles.icon_notification} src="/assets/navbar/menu/tests.png" />
                                <span className={styles.notification_number}>120</span>
                            </div>
                        </Dropdown> */}
                        <Dropdown
                            right
                            className={styles.dropdown}
                            onClick={handleTrackingClickNotification}
                            dropdownMenuClassName={classnames([styles.dropdown_menu])}
                            itemProps={
                                <Notification
                                    className={styles.notifications}
                                    bodyClassName={styles.body}
                                    notificationWrapperClassName={styles.notification_wrapper}
                                    scheduleWrapperClassname={styles.schedule_wrapper}
                                />
                            }
                        >
                            <div className={styles.with_notification}>
                                <ImgLazy className={styles.icon_notification} src="/assets/navbar/notification.png" />
                                {countNotification.total > 0 && (
                                    <span className={styles.notification_number}>{countNotification.total}</span>
                                )}
                            </div>
                        </Dropdown>

                        <Dropdown
                            right
                            itemProps={<Access />}
                            onClick={handleTrackingClickAvatar}
                            className={classnames([styles.avatar_group, styles.dropdown])}
                            dropdownMenuClassName={classnames([styles.dropdown_menu, styles.access_menu])}
                        >
                            <ImgLazy
                                className={styles.avatar}
                                src={getAttachmentAvatar(self?.id, 'consumer_profile')}
                            />
                            <ImgLazy className={styles.icon_setting} src="/assets/navbar/menu/setting.svg" />
                        </Dropdown>
                    </>
                ) : (
                    <div className={styles.authenticate_dropdown}>
                        <div className={styles.authenticate}>
                            <div className={styles.btn_authenticate} onClick={toggleModal}>
                                Đăng ký / Đăng nhập
                            </div>
                            <span className={styles.help_text}>Đăng nhập để xem kết quả</span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default DesktopNavbar;
